import { useMediaQuery } from '@mui/material';
import React, { createContext, useContext, useState } from 'react';

import { NAV_BAR_MOBILE_BREAKPOINT } from '../Components/styleConstants';

interface IResponsiveController {
  condensedUtilityTray: boolean;
  isMobileBreakpointWidth: boolean;
  mobileBreakpointOverride: number | null;
  navBarContainerRef: React.RefObject<HTMLDivElement>;
  setMobileBreakpointOverride: React.Dispatch<React.SetStateAction<number>>;
  setCondensedUtilityTray: React.Dispatch<React.SetStateAction<boolean>>;
}

interface IResponsiveControllerProviderProps {
  children: React.ReactNode;
  navBarContainerRef: React.RefObject<HTMLDivElement>;
}

const ResponsiveController = createContext<IResponsiveController | undefined>(undefined);

export const ResponsiveControllerProvider: React.FC<IResponsiveControllerProviderProps> = ({
  children,
  navBarContainerRef
}) => {
  const [mobileBreakpointOverride, setMobileBreakpointOverride] = useState<number | null>(null);
  const [condensedUtilityTray, setCondensedUtilityTray] = useState(false);

  const isMobileBreakpointWidth = useMediaQuery(
    `(max-width:${mobileBreakpointOverride || NAV_BAR_MOBILE_BREAKPOINT}px)`
  );

  const providerValue = React.useMemo(
    () => ({
      navBarContainerRef,
      condensedUtilityTray,
      setCondensedUtilityTray,
      mobileBreakpointOverride,
      setMobileBreakpointOverride,
      isMobileBreakpointWidth
    }),
    [condensedUtilityTray, mobileBreakpointOverride, isMobileBreakpointWidth, navBarContainerRef]
  );
  return <ResponsiveController.Provider value={providerValue}>{children}</ResponsiveController.Provider>;
};

export const useResponsiveController = () => {
  const context = useContext(ResponsiveController);
  /* istanbul ignore next */
  if (!context) {
    throw new Error('useResponsiveController must be used within a MenuProvider');
  }
  return context;
};
